import React from "react"
import styled from "styled-components"
import { useFormContext } from "react-hook-form"
import { ErrorMessage } from "@hookform/error-message"
import { kv } from "~/utils/functions"
import ErrorField from "./ErrorField"
import { Values } from "~/model/Config"
import AcIcon from "~/components/atoms/AcIcon"

/**
 * セレクト・オプション
 */
export interface Value extends Values {
  label: string
  value: number | string
  selected?: boolean
}

interface Props {
  /**
   * 名前
   */
  name?: string

  /**
   * クラス
   */
  className?: string

  /**
   * 表示するデータ
   */
  dataSource: Value[]

  /**
   * 選択値
   */
  value?: string | number

  /**
   * 確認画面モード
   */
  isConfirm?: boolean

  /**
   * バリデーション
   */
  validations?: {
    required?: boolean
  }

  /**
   * エラー時のタイトル
   */
  error?: string

  /**
   * チェンジイベント
   */
  onChange?: (value: string | number | null | any) => void

  /**
   * 選択データ取得種別
   */
  isSelectRealValue?: boolean
  disabled?: boolean
  unit?: string
  displayNull?: string
}

export default function AcSelect(props: Props) {
  const {
    dataSource,
    value = null,
    name,
    isConfirm = false,
    validations,
    error,
    onChange,
    className,
    isSelectRealValue = false,
    disabled = false,
    unit,
    displayNull = "",
  } = props
  const inputDataSource = kv(dataSource, "value")
  const { register, formState } = useFormContext()

  const options = {
    onChange: (e) => {
      const value = dataSource[e.target.selectedIndex].value
      // setCurrentValue(value)
      if (!isSelectRealValue) {
        onChange?.apply(this, [value])
      } else {
        onChange?.apply(this, [dataSource[e.target.selectedIndex]])
      }
    },
  }

  if (validations?.required) {
    Object.assign(options, {
      required: !disabled && !value ? `${error || name}を選択してください` : false,
    })
  } else {
    Object.assign(options, {
      required: false,
    })
  }

  return isConfirm ? (
    <>
      <Label className={`form-label isConfirm`}>{`${inputDataSource[value]?.label || displayNull} ${
        unit || ""
      }`}</Label>
    </>
  ) : (
    <>
      <Content className={className}>
        <Select {...register(name, options)} value={value} disabled={disabled}>
          {dataSource.map((data, index) => (
            <option key={index} value={data.value}>
              {data.label}
            </option>
          ))}
        </Select>
        <AcIcon name="chevron-down" className="arrow-icon" />
        <ErrorMessage
          errors={formState.errors}
          name={name}
          render={({ message }) => <ErrorField role="alert">{message}</ErrorField>}
        />
      </Content>
    </>
  )
}

const Label = styled.label`
  display: block;
  position: relative;
  padding-left: 30px;

  &.isConfirm {
    padding-left: 0px;
  }
`
const Content = styled.div`
  position: relative;
  .arrow-icon {
    position: absolute;
    top: 9px;
    right: 5px;
    font-size: 0.9em;
  }
`
const Select = styled.select`
  &:disabled {
    background-color: #e6e6e6 !important;
  }
  font-size: 16px;
  display: block;
  width: 100%;
  border: 1px solid #bdbfc8;
  padding: 13px 10px;
  border-radius: 4px;
  background-color: #ffffff;
`
